import React from 'react';

import { surveyAnalytics } from '@r1-frontend/survey/analytics';
import { closePopup } from '@r1-frontend/survey/context/actions';
import { useCtxDispatch, useCtxSelector } from '@r1-frontend/survey/context/hooks';
import useSurvey from '@r1-frontend/survey/context/hooks/useSurvey';
import { getDialogDetails, getNeedToShowDialog } from '@r1-frontend/survey/context/selectors';
import { SurveyType } from '@r1-frontend/survey/context/surveys';

import breakpoints from '@r1-frontend/ui-kit/themes/breakpoints';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { SurveyPopup } from './desktop';
import { SurveySheet } from './mobile';

const SurveyDialog = () => {
    const isDesktop = useMatchMediaByWidth(breakpoints.mobile, true);

    const dispatch = useCtxDispatch();

    const needToShow = useCtxSelector(getNeedToShowDialog);
    const dialogDetails = useCtxSelector(getDialogDetails);

    const survey = useSurvey();

    // TODO: после перехода на внутренние опросы поменять логику и название
    const startHandler = (surveyType: SurveyType, surveyName: string, activeTo?: Date) => () => {
        survey.markAsCompleted(surveyType, surveyName, activeTo);
        surveyAnalytics.common.clickTakeSurvey();
        dispatch(closePopup());
    };

    const closeHandler = () => {
        surveyAnalytics.common.closePopup();
        dispatch(closePopup());
    };

    if (!needToShow || !dialogDetails) {
        return null;
    }

    const { type, name, activeTo, ...details } = dialogDetails;

    const componentProps = {
        ...details,
        onStart: startHandler(type, name, activeTo),
        onClose: closeHandler,
    };

    return isDesktop ? <SurveyPopup {...componentProps}/> : <SurveySheet {...componentProps}/>;
};

export { SurveyDialog };
